import * as React from 'react'
function SvgPhone(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34.57 28.61l-5.156-5.188a1.999 1.999 0 00-2.832-.004L22 28 12 18l4.588-4.588c.78-.78.782-2.046.002-2.828l-5.16-5.168a2 2 0 00-2.83 0l-4.592 4.59L4 10c0 14.36 11.64 26 26 26l4.566-4.566c.78-.78.782-2.042.004-2.824z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgPhone
